import { en, fr, nl } from '@formkit/i18n'
import { genesisIcons } from '@formkit/icons'
import { createProPlugin, datepicker } from '@formkit/pro'
import { defineFormKitConfig } from '@formkit/vue'
import stepNumber from '~/formkit/inputs/stepNumber'
import submit from '~/formkit/inputs/submit'
import { addAsteriskPlugin } from '~/formkit/plugins/asteriskWhenRequired'
import { combineGroupPlugin } from '~/formkit/plugins/combineGroupPlugin'
import { scrollToErrors } from '~/formkit/plugins/scrollToErrors'
import { rootClasses } from './formkit.theme.mjs'
import '@formkit/pro/genesis'
const pro = createProPlugin('fk-728317b681', { datepicker })
// TODO: move to separate file

export default defineFormKitConfig({
    plugins: [ pro, addAsteriskPlugin, scrollToErrors, combineGroupPlugin ],
    locales: { en, fr, nl },
    locale: 'nl',
    icons: {
        ...genesisIcons
    },
    config: {
        rootClasses
    },
    inputs: {
        submit,
        stepNumber
    }
})
